module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-onslaught.5c429bfc.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-onslaught.png
// module id = 2825
// module chunks = 11